module.exports = __webpack_public_path__ + "static/media/modular-rug.66a719b5.jpg";